import type { FC } from 'react';
import PopFilterButton from './PopFilterButton';
import { useUrlParams } from '../../../../../hooks';
import { useDiscoverStore } from '../../../../../zustand-stores';
import updateFilterCollapsed from '../../../../../zustand-stores/DiscoverStore/actions/updateFilterCollapsed';

const VoloPassExclusivePopFilter: FC = () => {
  const { updateUrlParams } = useUrlParams();

  const voloPassExclusiveOnly = useDiscoverStore(store => store.filters.voloPassExclusiveOnly);

  const handlePress = () => {
    updateUrlParams({ voloPassExclusiveOnly: voloPassExclusiveOnly ? undefined : true });
    updateFilterCollapsed('voloPassMembershipPerks', !!voloPassExclusiveOnly);
  };

  return (
    <PopFilterButton
      onPress={handlePress}
      label="Volo Pass - Member Exclusive Programs"
      pressed={voloPassExclusiveOnly}
    />
  );
};

export default VoloPassExclusivePopFilter;
